const eventBus = new EventTarget();

export const dispatchEvent = (name, detail = {}) => {
  eventBus.dispatchEvent(new CustomEvent(name, { detail }));
}; 

export const listenEvent = (name, handler) => {
  eventBus.addEventListener(name, handler);
  return () => eventBus.removeEventListener(name, handler);
};
